import { useState } from 'react';
import { noImageWrapper } from '@components/imageHandling/common';
import { ImageHandlingHeaderProps } from '@v2/components/imageHandling/components/Header/Header';

interface UseManageImageHandlingHeaderActionsParams extends Pick<ImageHandlingHeaderProps, 'images' | 'selectedIndex'> {}

export const useManageImageHandlingHeaderActions = ({ images, selectedIndex }: UseManageImageHandlingHeaderActionsParams) => {
  const [showInfoPopUp, setShowInfoPopUp] = useState(false);
  const triggerInfoPopUp = () => noImageWrapper({ fn: () => setShowInfoPopUp(!showInfoPopUp), images, selectedIndex });

  const [showCrop, setShowCrop] = useState(false);
  const triggerCrop = () => noImageWrapper({ fn: () => setShowCrop(!showCrop), images, selectedIndex });

  const [showRotatePopUp, setShowRotatePopUp] = useState(false);
  const triggerRotatePopUp = () => setShowRotatePopUp(!showRotatePopUp);

  return {
    showInfoPopUp,
    setShowInfoPopUp,
    triggerInfoPopUp,
    showCrop,
    setShowCrop,
    triggerCrop,
    showRotatePopUp,
    setShowRotatePopUp,
    triggerRotatePopUp,
  };
};
